import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { List } from "immutable";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { CodThreshold } from "../../models/cod-threshold.model";
import { PopoverComponent } from "../../panel/popover/popover.component";
import { ListItem } from "../list-item";

@Component({
  selector: "app-info-item-container",
  templateUrl: "./info-item.component.html",
  styleUrls: ["./info-item.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoItemComponent {
   @Input() infoItems = List<ListItem>();
   @Input() className: string;
   @Input() isSpecialHandling = false;
   @Input() codThresholds: CodThreshold[] = [];
   @Input() isLoadingCodThresholds = false;
   @Input() hasCodThresholdError = false;
   @Input() isCodVendor = false;
   @Output() enableSpecialHandling = new EventEmitter<boolean>();
   @Output() codThresholdIconClick = new EventEmitter<void>();

   getClass(item: ListItem): string {
     return item.value === this.className ? "activeItem" : "";
  }

   itemClass(item: ListItem): string {
    let addressClass = "address-detail";
    addressClass += item.key === "Address:" ? " special-handling-address" : "";
    return addressClass;
    }

   trackByIndex(index, item) {
    return index;
  }

   trackByProjectId(index: number, item: CodThreshold): number {
    return item.projectId;
  }

   isMixedRetriever(item: ListItem): boolean {
    return item.key === "Retriever:" && item.value === "Mixed";
  }

   showCodThresholdIcon(item: ListItem): boolean {
    return item.key === "3rd Party Vendor:" && this.isCodVendor;
  }

   get hasCodThresholds(): boolean {
    return ArrayHelper.isAvailable(this.codThresholds);
  }

   get activeProjectCountLabel(): string {
    const count = ArrayHelper.clean(this.codThresholds).length;
    return `ACTIVE PROJECT${count === 1 ? "" : "S"} : ${count}`;
  }

   specialHandling(value: boolean): void {
    this.enableSpecialHandling.emit(value);
  }

   onCodThresholdIconClick(event: Event, popover: PopoverComponent): void {
    popover.toggle(event);
    if (popover.visible) {
      this.codThresholdIconClick.emit();
    }
  }
}
